import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthRoute } from '@portal-core/auth/enums/auth-route.enum';
import { AuthRouteService } from '@portal-core/auth/services/auth-route.service';
import { AuthService } from '@portal-core/auth/services/auth.service';
import { Observable, map } from 'rxjs';

/**
 * Redirects the user to the home page if they are already logged in. Otherwise, redirects to the login page.
 */
export const pageNotFoundGuard: CanActivateFn = (): Observable<boolean> => {
  const authService = inject(AuthService);
  const authRouteService = inject(AuthRouteService);

  const authRoute = authService.isAuthenticated() ? AuthRoute.Home : AuthRoute.Login;

  return authRouteService.navigateToAuthRoute$(authRoute, { replaceUrl: true }).pipe(
    map(() => false)
  );
}
